/**
 * Canonical Hub360 profile keys aligned with backend `role_constants`.
 */

export const ROLE = {
  ADMIN_WES: 'admin_wes',
  ADMIN_CLIENTE: 'admin_cliente',
  USUARIO_COMUM: 'usuario_comum',
};

/** Legacy aliases → canonical (subset used by UI). */
const LEGACY_TO_CANONICAL = {
  superuser: ROLE.ADMIN_WES,
  Superuser: ROLE.ADMIN_WES,
  admin_wes: ROLE.ADMIN_WES,
  admin: ROLE.ADMIN_CLIENTE,
  Admin: ROLE.ADMIN_CLIENTE,
  admin_cliente: ROLE.ADMIN_CLIENTE,
  user: ROLE.USUARIO_COMUM,
  User: ROLE.USUARIO_COMUM,
  usuario_comum: ROLE.USUARIO_COMUM,
};

/** Portuguese fallbacks when i18n is unavailable. */
export const ROLE_LABEL_FALLBACK_PT = {
  admin_wes: 'Admin WES',
  admin_cliente: 'Admin Cliente',
  usuario_comum: 'User Cliente',
  viewer: 'Visualizador',
};

/**
 * Roles that bypass route permission pairing (mirror backend admin bypass lists).
 */
export const HUB_ROUTE_ADMIN_ROLE_LIST = [
  ROLE.ADMIN_WES,
  ROLE.ADMIN_CLIENTE,
  'superuser',
  'Superuser',
  'admin',
  'Admin',
];

export const HUB_ROUTE_ADMIN_WES_ROLE_LIST = [
  ROLE.ADMIN_WES,
  'superuser',
  'Superuser',
];

export function resolveCanonicalRoleName(name) {
  if (!name) return name;
  return LEGACY_TO_CANONICAL[name] || name;
}

export function isHubRouteAdminBypass(roles = []) {
  if (!Array.isArray(roles)) return false;
  return roles.some((r) => HUB_ROUTE_ADMIN_ROLE_LIST.includes(r));
}

/**
 * @param {string} rawRole — DB/API role key
 * @param {Function} [t] — i18next `t` function
 */
export function getRoleLabel(rawRole, t) {
  if (!rawRole) return '';
  const canon = resolveCanonicalRoleName(rawRole);
  const key = `common.rolesProfile.${canon}`;
  if (typeof t === 'function') {
    const out = t(key, {
      defaultValue: ROLE_LABEL_FALLBACK_PT[canon] || rawRole,
    });
    return out;
  }
  return ROLE_LABEL_FALLBACK_PT[canon] || rawRole;
}

/**
 * Permissions arrive either as plain strings or as `{ name }` objects,
 * depending on which endpoint served them.
 */
export function normalizePermissionName(permission) {
  if (typeof permission === 'string') return permission;
  if (permission?.name) return String(permission.name);
  return String(permission);
}

/**
 * A role carrying any `health_care:*` permission requires a CRM verified
 * against the hospital-api before it can be assigned. Lives here because both
 * the users page (write path) and the user form modal (submit gating) need it.
 */
export function roleRequiresCrm(role) {
  return (role?.permissions || []).some((permission) =>
    normalizePermissionName(permission).startsWith('health_care:')
  );
}
